angular
    .module('eficienciaFiscalModule')
    .filter('limitToDots', ($filter) => {
        return (input, limit, begin, dots) => {
            if (!input || input.length <= limit) {
                return input;
            }

            begin = begin || 0;
            dots = dots || '...';

            return $filter('limitTo')(input, limit, begin) + dots;
        };
    });